var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      this.shared_user
        ? _c("div", { staticClass: "card p-05" }, [
            _c("div", { staticClass: "d-flex justify-content-start mb-05 " }, [
              _c("div", [
                _c("img", {
                  staticClass: "round",
                  attrs: {
                    src:
                      this.shared_user !== null &&
                      this.shared_user.user.avatar !== null
                        ? this.shared_user.user.avatar.url
                        : "/images/avatar.png",
                    alt: "avatar",
                    height: "30",
                    width: "30",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "p-0 justify-content-start" }, [
                _c("div", { staticClass: "user-name text-bold-600" }, [
                  _c(
                    "div",
                    { staticClass: "dropdown dropdown-user nav-item" },
                    [
                      _c("a", {
                        staticClass: "dropdown-toggle dropdown-user-link",
                        attrs: { href: "#", "data-toggle": "dropdown" },
                        domProps: {
                          textContent: _vm._s(
                            this.shared_user.user.first_name +
                              " " +
                              this.shared_user.user.last_name
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _vm._l(this.shared_user.user.badges, function (badge) {
                        return _c("span", [
                          _c("img", {
                            staticStyle: {
                              "margin-top": "-3px",
                              height: "15px",
                            },
                            attrs: {
                              src: badge.image,
                              "data-toggle": "tooltip",
                              "data-placement": "bottom",
                              title: badge.name,
                            },
                          }),
                        ])
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "text-bold-400" }, [
                        _vm._v("shared a meeting"),
                      ]),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { "margin-top": "-3px", "line-height": "1" } },
                  [
                    _c("span", {
                      staticClass: "font-small-2 text-light",
                      domProps: {
                        textContent: _vm._s(this.shared_user.user.position),
                      },
                    }),
                    _c("span", { staticClass: "font-small-2 text-light" }, [
                      _vm._v(" at "),
                    ]),
                    _c("span", {
                      staticClass: "font-small-2 text-light",
                      domProps: {
                        textContent: _vm._s(this.shared_user.user.organisation),
                      },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "btn-group mt-05",
                  staticStyle: { right: "0.5rem", position: "absolute" },
                },
                [
                  _c("span", {
                    staticClass: "font-small-1 text-light ",
                    staticStyle: { "margin-top": "3px" },
                    domProps: {
                      textContent: _vm._s(_vm.ago(this.data.created_at)),
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "dropdown" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "dropdown-menu",
                        attrs: { "aria-labelledby": "dropdownMenuButton200" },
                      },
                      [
                        _vm.isServiceAdmin === true ||
                        _vm.user_id === _vm.data.module.owner.id ||
                        _vm.isAdmin === true
                          ? _c("span", [
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.editPost.apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "feather icon-settings",
                                  }),
                                  _vm._v(_vm._s(_vm.__("globals.edit_post"))),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isServiceAdmin === true ||
                        _vm.user_id === _vm.data.module.owner.id ||
                        _vm.isAdmin === true
                          ? _c("span", [
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.destroy.apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "feather icon-trash-2",
                                  }),
                                  _vm._v(_vm._s(_vm.__("globals.delete_post"))),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item danger",
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.report.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "feather icon-alert-triangle",
                            }),
                            _vm._v(_vm._s(_vm.__("globals.report_post"))),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm.editing
              ? _c("div", { staticClass: "form-group pr-1 pl-1" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.body,
                        expression: "body",
                      },
                    ],
                    staticClass: "form-control mb-1",
                    domProps: { value: _vm.body },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.body = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-primary",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.updateNewsfeed.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.__("globals.update")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-link",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.editing = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.__("globals.cancel")))]
                  ),
                ])
              : _vm.body !== null
              ? _c("div", { staticClass: " p-05" }, [
                  _c("div", {
                    directives: [{ name: "linkified", rawName: "v-linkified" }],
                    staticClass: "breakAll pb-1",
                    domProps: {
                      innerHTML: _vm._s(
                        this.$options.filters.nl2br(_vm.body, true)
                      ),
                    },
                  }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex justify-content-center" }, [
              _c("div", { staticClass: "card border-light w-100" }, [
                _c("div", { staticClass: "d-flex justify-content-start" }, [
                  _c("div", [
                    this.shared_user.user !== null &&
                    this.shared_user.supplier_user.length === 0
                      ? _c(
                          "div",
                          [
                            _c("post-owner-info", {
                              attrs: {
                                data: _vm.data,
                                isServiceAdmin: _vm.isServiceAdmin,
                                user_id: _vm.user_id,
                              },
                            }),
                          ],
                          1
                        )
                      : this.shared_user.supplier_user.length > 0
                      ? _c("div", [
                          _c(
                            "div",
                            { staticClass: "d-flex justify-content-start " },
                            [
                              _c("div", { staticClass: "p-05" }, [
                                _c("img", {
                                  staticClass: "round",
                                  attrs: {
                                    src:
                                      this.shared_user.supplier_user.length >
                                        0 &&
                                      this.shared_user.supplier_user[0]
                                        .supplier_avatar !== null
                                        ? this.shared_user.supplier_user[0]
                                            .supplier_avatar.url
                                        : "/images/avatar.png",
                                    alt: "avatar",
                                    height: "30",
                                    width: "30",
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "p-05 justify-content-start" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "user-name text-bold-600 text-dark",
                                    },
                                    [
                                      _c("div", { staticClass: "nav-item" }, [
                                        _c("a", {
                                          staticClass:
                                            "dropdown-toggle dropdown-user-link",
                                          attrs: {
                                            href:
                                              "/member/supplier/" +
                                              this.shared_user.supplier_user[0]
                                                .slug,
                                            "data-toggle": "dropdown",
                                          },
                                          domProps: {
                                            textContent: _vm._s(
                                              this.shared_user.supplier_user[0]
                                                .title
                                            ),
                                          },
                                        }),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticStyle: { "margin-top": "-5px" } },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "font-small-2 text-primary",
                                        },
                                        [
                                          _vm._v(
                                            "@" +
                                              _vm._s(
                                                this.shared_user
                                                  .supplier_user[0].slug
                                              )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "btn-group mt-05",
                      staticStyle: { right: "0.5rem", position: "absolute" },
                    },
                    [
                      _c("span", {
                        staticClass: "font-small-1 text-light ",
                        staticStyle: { "margin-top": "4px" },
                        domProps: {
                          textContent: _vm._s(
                            _vm.ago(this.data.module.created_at)
                          ),
                        },
                      }),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-content" }, [
                  _c(
                    "div",
                    {
                      staticClass: "card-img-top img-fluid",
                      attrs: { id: "gallery-" + _vm.data.id },
                    },
                    [
                      _c("img", {
                        staticClass: " img-fluid",
                        attrs: {
                          src:
                            _vm.data.module.cover === null
                              ? "/images/cover.jpg"
                              : _vm.data.module.cover.url,
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-body p-0" }, [
                    _c("div", { staticClass: "d-flex" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "mt-0 ml-1 mr-1 mb-0 pt-1 border-top align-items-center justify-content-start",
                        },
                        [
                          _c("span", { staticClass: "h3" }, [
                            _c("a", {
                              staticStyle: { color: "inherit" },
                              attrs: {
                                href: "/member/zoom/" + _vm.data.module.zoom_id,
                              },
                              domProps: {
                                textContent: _vm._s(_vm.data.module.title),
                              },
                            }),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "ml-auto mt-0 ml-1 mr-1 mb-0 pt-1" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "badge badge-pill bg-gradient-secondary",
                              staticStyle: { padding: "0.2rem 0.5rem" },
                            },
                            [
                              _c("i", { staticClass: "feather icon-video" }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.__("meeting.title_singular")) +
                                  "\n                                "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-flex ml-1 mr-1 mt-0" }, [
                      _vm._m(1),
                      _c("span", {
                        staticClass: "h6 primary",
                        domProps: { textContent: _vm._s(_vm.showDateTime) },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: " m-05 pt-1 pl-05 pr-0 border-top" },
                      [
                        _c("div", {
                          directives: [
                            { name: "linkified", rawName: "v-linkified" },
                          ],
                          staticClass: "breakAll mb-0",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.data.module.description.substring(0, 550)
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "a",
                            {
                              staticClass: "font-small-3",
                              attrs: {
                                href: "/member/zoom/" + _vm.data.module.zoom_id,
                              },
                            },
                            [
                              _vm._v(_vm._s(_vm.__("globals.read_more")) + " "),
                              _c("i", {
                                staticClass: "feather icon-chevron-right",
                              }),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card-body border-top ml-05 mr-05 p-0" },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-between" },
                        [
                          _c(
                            "div",
                            { staticClass: " p-05" },
                            [
                              _c("like", {
                                attrs: { post: _vm.data.module, type: "post" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "p-05 font-small-3 text-bold-700" },
                            [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.showComments(_vm.data.id)
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "fa fa-comment-o" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.__("globals.comment")) +
                                      " "
                                  ),
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(_vm.commentsCount),
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("comments", {
        attrs: {
          data: _vm.data.module.comments,
          newsfeed_id: _vm.data.id,
          module: _vm.data.type,
          slug: _vm.data.module.id,
          members: _vm.members,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn-sm btn-outline-light dropdown-toggle ",
        staticStyle: { border: "none" },
        attrs: {
          type: "button",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false",
        },
      },
      [_c("i", { staticClass: "fa fa-chevron-circle-down mr-0" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h6", { staticClass: "primary mr-05" }, [
      _c("i", { staticClass: "feather icon-calendar" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }